import React from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import chistory from "../../Shared/history";
import paginationFactory from "react-bootstrap-table2-paginator";
import TableCustomTotal from "../../Shared/TableCustomTotal";
import { Spinner } from "reactstrap";

const NoDataIndication = () => (
  <div class="container h-100">
    <div class="row NoDataFoundTable">
      <h5>No Data Found!</h5>
    </div>
  </div>
);
const showListType = (cell) => {
  if (cell == 1) {
    return "Area";
  } else if (cell == 2) {
    return "Facility";
  }
  if (cell == 3) {
    return "Region";
  }
  if (cell == 4) {
    return "Team";
  }
  if (cell == 5) {
    return "Saved Search";
  }
  if (cell == 6) {
    return "Registration";
  }
};
const showListAccessLevel = (cell) => {
  if (cell == 1) {
    return "ReadOnly";
  } else if (cell == 2) {
    return "Members";
  }
  if (cell == 3) {
    return "Anyone";
  }
};
////Start of the Component
const MailingListTable = (props) => {
  const { listData, loading } = props;
  const columns = () => [
    {
      dataField: "email_Title",
      text: "LIST TITLE",

      headerClasses: "bg-dark text-white px-sm-3 px-2 py-2",
      classes: "px-3 py-2 c-pointer", //console.log("click rowEvents disabled in prod.");
      //classes: "px-3 py-2",

      sort: true,
    },
    {
      text: "EMAIL ADDRESS",
      headerClasses: "bg-dark text-white px-sm-3 px-2 py-2",
      classes: "px-3 py-2 c-pointer", //console.log("click rowEvents disabled in prod.");
      //classes: "px-3 py-2",
      sort: true,
      dataField: "email_Address",
    },
    {
      text: "EMAIL LIST TYPE",
      dataField: "email_List_Type_Id",
      headerClasses: "bg-dark text-white px-sm-3 px-2 py-2",
      formatter: (cellContent, row) => showListType(cellContent),
      hidden: true,
    },
    {
      text: "Access Level",
      dataField: "email_privilege",
      headerClasses: "bg-dark text-white px-sm-3 px-2 py-2",
      formatter: (cellContent, row) => showListAccessLevel(cellContent),
      hidden: true,
    },
    {
      text: "EMAIL ENTITY TYPE",
      dataField: "entity_key",
      hidden: true,
    },
    //Primary key of
    //saved_search_email_list
    //facility_region_email_list
    {
      text: "EMAIL LIST ID",
      dataField: "id",
      hidden: true,
    },
    {
      text: "MAILING LIST NAME",
      dataField: "mailingListName",
      hidden: true,
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      chistory.push(`/admin/email-list/view/${row.id}`, {
        emailListDetails: { ...row },
      });
      //console.log("click rowEvents disabled in prod.");
    },
  };
  const RemotePagination = (data, loading) => (
    <div>
      <BootstrapTable
        keyField="rowNumber"
        data={data}
        columns={columns()}
        loading={loading}
        pagination={paginationFactory({
          paginationTotalRenderer: TableCustomTotal,
        })}
        rowEvents={rowEvents}
        noDataIndication={() => {
          return loading === false ? (
            <NoDataIndication />
          ) : (
            <div className="d-flex justify-content-center p-4">
              <Spinner />
            </div>
          );
        }}
      />
    </div>
  );

  return <>{RemotePagination(listData, loading)}</>;
};

MailingListTable.propTypes = {
  listData: PropTypes.array.isRequired,
};

MailingListTable.defaultProps = {
  listData: [],
};

export default MailingListTable;
